module.exports = __webpack_public_path__ + "static/media/2DPlan.0e88a66d.svg";